import {WhitespaceValidator} from '@spa/validators';

import {BaseControl, SelectControl} from 'appShared/classes/controls';
import {ComponentTypesEnum} from 'appShared/enums/common';
import {DialogButtonTypesEnum, DialogConfigInterface, SelectOptionInterface} from 'appShared/components';
import {Validators} from '@angular/forms';

export const AddNewExchangeNameSelector = 'addNewExchangeName';
export const AddNewExchangeCodeSelector = 'addNewExchangeCode';
export const AddNewExchangeAgreementTypesSelector = 'addNewExchangeAgreementTypes';
export const AddNewExchangeReportStartDaySelector = 'addNewReportStartDayCode';
export const AddNewExchangeReportEndDaySelector = 'addNewReportEndDayCode';

export const AddNewExchangeDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};

export const AddNewExchangeControls = (agreementTypes: Record<string, string>): BaseControl[] => {
    return [
        new BaseControl({
            name: AddNewExchangeNameSelector,
            value: '',
            placeholder: 'Name',
            validators: [WhitespaceValidator()],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewExchangeCodeSelector,
            value: '',
            placeholder: 'Code',
            validators: [WhitespaceValidator()],
            componentType: ComponentTypesEnum.Textarea,
        }),
        new SelectControl({
            name: AddNewExchangeReportStartDaySelector,
            value: null,
            placeholder: 'Report Start Day',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: getDayOfMonth()
        }),
        new SelectControl({
            name: AddNewExchangeReportEndDaySelector,
            value: null,
            placeholder: 'Report End Day',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: getDayOfMonth()
        }),
        new SelectControl({
            name: AddNewExchangeAgreementTypesSelector,
            value: null,
            placeholder: 'Agreement Types',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: getAgreementOptions(agreementTypes),
            multiple: true
        }),
    ];
};
const getDayOfMonth = (): SelectOptionInterface[] => {

    const days: SelectOptionInterface[] = [];

    for (let i = 1; i <= 31; i++) {
        days.push({value: i, label: i.toString()});
    }

    return days;
};

const getAgreementOptions = (agreementTypes: Record<string, string>): SelectOptionInterface[] => {
    if (!agreementTypes) {
        return [];
    }

    return Object.keys(agreementTypes).map(key => ({
        value: key,
        label: agreementTypes[key]
    }));
};
